import { Route } from 'react-router';

import { PREF_CARDS_BASE_ROUTE } from './shared/constants';

export function getCardOptimizerRoutes(hasCardOptimizerV2: boolean) {
  if (hasCardOptimizerV2) {
    return (
      <Route
        id="co-root"
        path={PREF_CARDS_BASE_ROUTE}
        lazy={() => import('routes/card-optimizer/card-optimizer.layout')}
      >
        <Route path="*" lazy={() => import('routes/card-optimizer/card-optimizer-nav.layout')}>
          <Route index lazy={() => import('routes/card-optimizer/preference-cards/preference-cards.route')} />
          <Route path="clinical-locations" lazy={() => import('routes/card-optimizer/resources/clinical-locations')} />
        </Route>

        <Route path="procedures">
          <Route index lazy={() => import('routes/card-optimizer/procedures/procedures.route')} />
          <Route
            path=":procedureId"
            id="procedure-card-detail"
            lazy={() => import('routes/card-optimizer/procedure-detail/procedure-detail.route')}
          >
            <Route
              index
              id="procedure-detail-items"
              lazy={() => import('routes/card-optimizer/procedure-detail-items/procedure-detail-items.route')}
            />
            <Route
              path="preference-cards"
              lazy={() =>
                import(
                  'routes/card-optimizer/procedure-detail-preference-cards/procedure-detail-preference-cards.route'
                )
              }
            />
          </Route>
        </Route>
        <Route
          path=":cardId"
          id="co-card"
          lazy={() => import('routes/card-optimizer/preference-card-detail/preference-card-detail.route')}
        >
          <Route
            id="co-card-items"
            index
            lazy={() => import('routes/card-optimizer/preference-card-detail-items/preference-card-detail-items.route')}
          />
          <Route
            path="requests"
            lazy={() =>
              import('routes/card-optimizer/preference-card-detail-requests/preference-card-detail-requests.route')
            }
          />

          <Route
            path="tasks"
            lazy={() => import('routes/card-optimizer/preference-card-detail-tasks/preference-card-detail-tasks.route')}
          />

          <Route
            id="co-card-standardization"
            path="standardization"
            lazy={() =>
              import(
                'routes/card-optimizer/preference-card-detail-standardization/preference-card-detail-standardization.route'
              )
            }
          />
        </Route>

        <Route
          path="preference-card-client-items/:clientItemId"
          lazy={() => import('routes/card-optimizer/resources/preference-cards-client-item')}
        />
        <Route path="items/:clientItemId" lazy={() => import('routes/card-optimizer/resources/client-item')} />
        <Route
          path="preference-card-client-item-summary/:clientItemId"
          lazy={() => import('routes/card-optimizer/resources/preference-cards-client-item-summary')}
        />
        <Route
          path="preference-card-items-snooze"
          lazy={() => import('routes/card-optimizer/resources/preference-cards-items-snooze')}
        />
        <Route
          path="preference-card-change-requests"
          lazy={() => import('routes/card-optimizer/resources/preference-card-change-requests')}
        />
        <Route path="service-lines" lazy={() => import('routes/resources/service-lines')} />
        <Route path="primary-physicians" lazy={() => import('routes/resources/primary-physicians')} />
        <Route path="locations" lazy={() => import('routes/resources/locations')} />
        <Route path="clinical-procedures" lazy={() => import('routes/resources/clinical-procedures')} />
        <Route path="client-items-search" lazy={() => import('routes/resources/client-items-search')} />
        <Route
          path="search-procedure-cards"
          lazy={() => import('routes/card-optimizer/resources/search-procedure-cards')}
        />

        <Route
          path="search-procedure-card-recommendations"
          lazy={() => import('routes/card-optimizer/resources/search-procedure-card-recommendations')}
        />
        <Route
          path="preference-card-value-ranges"
          lazy={() => import('routes/card-optimizer/resources/preference-card-value-ranges')}
        />
      </Route>
    );
  }

  return (
    <Route
      id="co-root"
      path={PREF_CARDS_BASE_ROUTE}
      lazy={() => import('pages/preference-cards/routes/preference-cards')}
    >
      <Route path="*" lazy={() => import('pages/preference-cards/routes/queue-layout')}>
        <Route index lazy={() => import('pages/preference-cards/routes/preference-cards.index')} />
        <Route path="requests" lazy={() => import('pages/preference-cards/routes/preference-cards.requests')} />
        <Route
          path="recommendations"
          id="co-recommendations-queue"
          lazy={() => import('pages/preference-cards/routes/recommendations/co.recommendations')}
        />
        <Route
          id="co-procedure-queue"
          path="procedures"
          lazy={() => import('pages/preference-cards/routes/procedures/procedures')}
        />
      </Route>
      <Route
        path="recommendations/:recommendationId"
        lazy={() => import('pages/preference-cards/routes/recommendations/co.$recommendationId')}
      >
        <Route index lazy={() => import('pages/preference-cards/routes/recommendations/co.$recommendationId.index')} />
        <Route
          path="preference-cards"
          lazy={() => import('pages/preference-cards/routes/recommendations/co.$recommendationId.preference-cards')}
        />
      </Route>
      <Route
        id="procedure-card-detail"
        path="procedures/:procedureId"
        lazy={() => import('pages/preference-cards/routes/procedures/procedures.$procedureId')}
      >
        <Route index lazy={() => import('pages/preference-cards/routes/procedures/procedures.$procedureId.index')} />
        <Route
          path="preference-cards"
          lazy={() => import('pages/preference-cards/routes/procedures/procedures.$procedureId.preference-cards')}
        />
        <Route
          path="activity"
          lazy={() => import('pages/preference-cards/routes/procedures/procedures.$procedureId.activity')}
        />
      </Route>
      <Route path=":cardId" id="co-card" lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId')}>
        <Route
          id="co-card-items"
          index
          lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId.index')}
        />
        <Route path="requests" lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId.requests')} />

        <Route path="tasks" lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId.tasks')} />
        <Route
          id="co-card-standardization"
          path="standardization"
          lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId.standardization')}
        />
      </Route>
      <Route
        path=":cardId/requests/:requestId"
        lazy={() => import('pages/preference-cards/routes/preference-cards.$cardId.requests.$requestId')}
      />
      <Route path="ch-data" lazy={() => import('pages/preference-cards/routes/preference-cards.ch-data')} />
    </Route>
  );
}
